<template>
  <div class="languages" id="select-language">
    <Select2
      @select="select($event)"
      v-model="selectedItems"
      :options="selectOptions"
      :settings="selectConfig"
      ref="select2"
    />
  </div>
</template>

<script>
  import Select2 from 'v-select2-component'
  import config from '@/config.js'

  export default {
    name: 'LanguageSelect',
    props: ['exclude', 'language', 'multiple'],
    components: {
      Select2
    },
    data(){
      return {
        selectedItems: this.multiple
          ? (this.language || []).map(item => item.code)
          : [this.language?.code],
        selectedObjs: this.language || (this.multiple ? [] : null)
      }
    },
    mounted() {
      if (config.staticData && !this.$store.state.common.languages.length) {
        this.$store.dispatch('loadLanguages').catch(() => {
          // The store action displays the required lookup error.
        })
      }
      if (this.language) {
        if (this.multiple) {
          this.language.forEach(lang => {
            this.$refs.select2.select2.append(
              `<option selected value="${lang.code}">${lang.name}</option>`
            ).trigger('change')
          })
        } else {
          this.$refs.select2.select2.append(
            `<option selected value="${this.language.code}">${this.language.name}</option>`
          ).trigger('change')
        }
      }
    },
    computed: {
      selectOptions() {
        if (!config.staticData) return []
        return this.$store.state.common.languages.map(language => ({
          id: language.code,
          text: language.name,
          language,
        }))
      },
      selectConfig(){
        const settings = {
          placeholder: "Select a language",
          allowClear: true,
          width: '100%',
          multiple: this.multiple ? true : false,
          dropdownParent: "#select-language",
        }
        if (!config.staticData) {
          settings.ajax = {
            delay: 250,
            url: config.apiUrl + '/languages/autocomplete',
            headers: config.apiHeaders,
            data: (params) => {
              return {
                query: params.term
              }
            },
            processResults: (data) => {
              return {
                results: data.map(language => {
                  return {
                    id: language.code,
                    text: language.name,
                    language: language
                  }
                })
              }
            }
          }
        }
        return settings
      }
    },
    methods: {
      select(event){
        if (this.multiple) {
          this.selectedObjs = this.selectedObjs.filter(language => this.selectedItems.includes(language.code))
        }

        if (event.selected){
          if (this.multiple) {
            this.selectedObjs.push(event.language)
          } else {
            this.selectedObjs = event.language
          }
        }

        if (this.multiple) {
          this.$emit('select', this.selectedObjs)
        } else {
          this.$emit('select', (event.selected ? event.language : null))

        }
      }
    }
  }
</script>
